import axios from "axios";

import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_DETAILS_REQUEST,
  USER_DETAILS_SUCCESS,
  USER_DETAILS_FAIL,
  USER_REGISTER_REQUEST,
  USER_REGISTER_SUCCESS,
  USER_REGISTER_FAIL,
  USER_LOGOUT,
  USER_UPDATE_REQUEST,
  USER_UPDATE_SUCCESS,
  USER_UPDATE_FAIL,
  USER_DETAILS_RESET,
  USER_UPDATE_RESET,
  SPONSORS_REQUEST,
  SPONSORS_SUCCESS,
  SPONSORS_FAIL,
  USER_REGISTER_RESET,
} from "../constants/userConstants";

import {
  PATIENT_DETAILS_RESET,
  PATIENT_LIST_RESET,
  PATIENT_REGISTER_RESET,
  PATIENT_UPDATE_RESET,
} from "../constants/patientConstants";
import {
  LIST_USER_CLINICS_RESET,
  CLINIC_CREATE_RESET,
  CLINIC_DETAILS_RESET,
  CLINIC_UPDATE_RESET,
} from "../constants/clinicConstants";

import { TRADE_LABELS_RESET } from "../constants/drugConstants";
import {
  LIST_CLINIC_VISITS_RESET,
  LIST_PATIENT_VISITS_RESET,
  VISIT_CREATE_RESET,
} from "../constants/visitConstants";

export const login = (inputs) => async (dispatch) => {
  try {
    dispatch({
      type: USER_LOGIN_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await axios.post(
      "/api/users/login",
      { email: inputs.email, password: inputs.password, token: inputs.token },
      config,
    );

    localStorage.setItem("userInfo", JSON.stringify(data));

    dispatch({
      type: USER_LOGIN_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: USER_LOGIN_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const registerUser = (newUser) => async (dispatch) => {
  try {
    dispatch({
      type: USER_REGISTER_REQUEST,
    });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const { data } = await axios.post(
      "/api/users",
      {
        prefixId: newUser.prefixId,
        firstName: newUser.firstName,
        lastName: newUser.lastName,
        email: newUser.email,
        phone: newUser.phone,
        password: newUser.password,
        token: newUser.token,
      },
      config,
    );
    dispatch({
      type: USER_REGISTER_SUCCESS,
      payload: data,
    });

    dispatch({
      type: USER_LOGIN_SUCCESS,
      payload: data,
    });
    localStorage.setItem("userInfo", JSON.stringify(data));
  } catch (error) {
    dispatch({
      type: USER_REGISTER_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getUserDetails = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_DETAILS_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(`/api/users/userDetails`, config);

    dispatch({
      type: USER_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (
      message === "Not authorized, token failed" ||
      message === "User not found" ||
      message === "Cannot read properties of null (reading 'id4Token')"
    ) {
      dispatch(logout());
    }
    dispatch({
      type: USER_DETAILS_FAIL,
      payload: message,
    });
  }
};

export const updateUserProfile = (user) => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_UPDATE_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.put(`/api/users/edit`, user, config);

    dispatch({
      type: USER_UPDATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (
      message === "Not authorized, token failed" ||
      message.includes("id4Token") ||
      message.includes("jwt expired") ||
      message.includes("invalid signature")
    ) {
      dispatch(logout());
    }
    dispatch({
      type: USER_UPDATE_FAIL,
      payload: message,
    });
  }
};

export const logout = () => (dispatch) => {
  localStorage.removeItem("userInfo");
  localStorage.removeItem("_grecaptcha");
  localStorage.removeItem("tradeLabels");

  dispatch({ type: TRADE_LABELS_RESET });
  dispatch({ type: USER_REGISTER_RESET });

  dispatch({ type: USER_LOGOUT });
  dispatch({ type: USER_DETAILS_RESET });
  dispatch({ type: USER_UPDATE_RESET });

  dispatch({ type: PATIENT_REGISTER_RESET });
  dispatch({ type: PATIENT_UPDATE_RESET });
  dispatch({ type: PATIENT_DETAILS_RESET });
  dispatch({ type: PATIENT_LIST_RESET });

  dispatch({ type: CLINIC_CREATE_RESET });
  dispatch({ type: CLINIC_DETAILS_RESET });
  dispatch({ type: CLINIC_UPDATE_RESET });
  dispatch({ type: LIST_USER_CLINICS_RESET });

  dispatch({ type: VISIT_CREATE_RESET });
  dispatch({ type: LIST_PATIENT_VISITS_RESET });
  dispatch({ type: LIST_CLINIC_VISITS_RESET });
};

export const listSponsors = (user) => async (dispatch, getState) => {
  try {
    dispatch({
      type: SPONSORS_REQUEST,
    });

    const { data } = await axios.get(`/api/users/listSponsors`);

    dispatch({
      type: SPONSORS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (
      message === "Not authorized, token failed" ||
      message.includes("id4Token") ||
      message.includes("jwt expired") ||
      message.includes("invalid signature")
    ) {
      dispatch(logout());
    }
    dispatch({
      type: SPONSORS_FAIL,
      payload: message,
    });
  }
};
